import axios from 'axios';
import apiConfig from '../config/apiConfig';
import { READER_TOKEN_KEY } from '../store/types/authTypes';

const TENANT_SLUG = (process.env.REACT_APP_TENANT_SLUG || '').trim().toLowerCase();

let readerToken = null;

export function getStoredReaderToken() {
  try {
    return localStorage.getItem(READER_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setReaderToken(token) {
  readerToken = token || null;
  try {
    if (token) {
      localStorage.setItem(READER_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(READER_TOKEN_KEY);
    }
  } catch {
    /* ignore */
  }
}

// Sync in-memory token on load
readerToken = getStoredReaderToken();

const apiClient = axios.create({
  baseURL: apiConfig.BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: apiConfig.TIMEOUT,
});

apiClient.interceptors.request.use((config) => {
  if (TENANT_SLUG) {
    config.headers['x-tenant-slug'] = TENANT_SLUG;
  }
  const token = readerToken || getStoredReaderToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
